import React, {
  FC, useState, ChangeEvent, useEffect
} from 'react';
import styles from './rangeSliderComponent.module.css';

type PropsType = {
  defaultValue?: number;
  onChange?: (value: string) => void;
  max: number;
  min: number;
};

const RangeSliderComponent: FC<PropsType> = ({
  defaultValue = '',
  onChange = () => {},
  max,
  min
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const onRangeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value);
    onChange(e.currentTarget.value);
  };

  const onDecrementValue = () => {
    const updatedValue = +value - 1;

    setValue(updatedValue);
    onChange(updatedValue.toString());
  };

  const onIncrementValue = () => {
    const updatedValue = +value + 1;

    setValue(updatedValue);
    onChange(updatedValue.toString());
  };

  return (
        <div className={styles.container}>
            <button disabled={+value <= min} onClick={onDecrementValue}>-</button>
            <input className={styles.rangeSlider} type="range" value={value} onChange={onRangeChange} max={max} min={min} />
            <button disabled={+value >= max} onClick={onIncrementValue}>+</button>
        </div>
  );
};

export default RangeSliderComponent;
